export default {
  setAppDetail(state, value) {
    state.app_detail = value;
  },
  setReviewProcess(state, data) {
    state.app_detail.review_process_id = data.review_process_id;
    state.app_detail.review_process_title = data.review_process_title;
    state.app_detail.review_process_title_en = data.review_process_title_en;
  },
};
